import { render, staticRenderFns } from "./dpd.vue?vue&type=template&id=5fc4d55b&"
import script from "./dpd.vue?vue&type=script&lang=js&"
export * from "./dpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dpd.vue"
export default component.exports